// src/pages/PriceChart.js
import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { RefreshCw, TrendingUp, TrendingDown } from 'lucide-react';
import api from '../api';
import { useNavigate } from 'react-router-dom';
import GoldChart from '../components/GoldChart';
export default function PriceChart() {
  

  return (
    <GoldChart height={450} />
  );
}